export const inViewPort = (
  element,
  callback,
  options = { rootMargin: '50px', threshold: 0.25 },
  delay = 0
) => {
  if (!element || !callback) return false

  const inViewObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const { target } = entry
        if (delay > 0) {
          setTimeout(() => {
            callback(target)
            inViewObserver.unobserve(target)
          }, delay)
          return
        }
        callback(target)
        inViewObserver.unobserve(target)
      }
    })
  }, options)

  inViewObserver.observe(element)

  return element
}

export const isInViewport = element => {
  const rect = element.getBoundingClientRect()
  const windowHeight =
    'innerHeight' in window
      ? window.innerHeight
      : document.documentElement.offsetHeight

  const top = rect.top + windowHeight <= windowHeight
  const bottom = rect.bottom >= windowHeight

  return top && bottom
}
